
























































































































import { Component, Vue, Watch, Ref } from "vue-property-decorator";
import ProductCard from "../components/ProductCard.vue";
import ContentCard from "../components/ContentCard.vue";
import Content from "../models/Content";
import { ProductDetail } from "@authentic-labs/vue-component-library";
import { Circle2 } from "vue-loading-spinner";
import RealModal from "../components/RealModal.vue";
import amplitude from "amplitude-js";
import {
  companyDetailEventArgs,
  PRODUCT_DETAIL_VIEWED_EVENT,
} from "@/utils/constants";

@Component({
  components: {
    ProductCard,
    ContentCard,
    ProductDetail,
    RealModal,
    Circle2,
  },
})
export default class ProductView extends Vue {
  @Watch("windowWidth")
  onPropertyChanged(value: string, oldValue: string) {
    if (this.windowWidth >= 768) {
      this.isTablet = false;
      this.isMobile = false;
      this.setColumnContent();
    } else if (this.windowWidth < 768 && this.windowWidth >= 576) {
      this.isTablet = true;
      this.isMobile = false;
      this.setColumnContent();
    } else if (this.windowWidth < 576) {
      this.isMobile = true;
      this.isTablet = false;
      this.videoModal.hide();
    }
  }
  @Ref()
  videoModal!: RealModal;
  get product() {
    return this.$store.getters.product;
  }
  get upArrowIcon() {
    return require("@/assets/icons/ArrowUpRight.svg");
  }

  isLoading = true;
  headerImageSrc = "";
  headerVideoSrc = "";
  headerSrc = "";
  hasVideo = false;
  isTablet = false;
  isMobile = false;
  videoSrc: string | null = "";
  publishedContent: Content[] = [];
  leftContent: Content[] = [];
  rightContent: Content[] = [];
  windowWidth = window.innerWidth;
  private startTime: Date = new Date();

  created() {
    window.innerWidth <= 768 && window.innerWidth > 576
      ? (this.isTablet = true)
      : (this.isTablet = false);
    window.innerWidth < 576 ? (this.isMobile = true) : (this.isMobile = false);
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
  }

  async mounted() {
    this.isLoading = true;
    const companyId = this.$route.params.companyId;
    const productId = this.$route.params.productId;
    await this.$store.dispatch("getProduct", { companyId, productId });
    if (this.product) {
      this.publishedContent = this.product.publishedContent as Content[];
      this.setColumnContent();
    }
    this.setHeaderSrc();
    this.isLoading = false;
    this.amplitudeProductDetailViewed();
    document.addEventListener("click", this.openVideoModal);
  }

  amplitudeProductDetailViewed() {
    amplitude.getInstance().logEvent(PRODUCT_DETAIL_VIEWED_EVENT, {
      duration: new Date().getTime() - this.startTime.getTime(),
      product: this.product,
      productId: this.product.productId,
    });
  }

  openVideoModal(e: Event) {
    if (
      e.target &&
      (e.target as HTMLDivElement).firstChild?.nodeName === "IFRAME"
    ) {
      e.preventDefault();
      this.videoSrc = (
        (e.target as HTMLDivElement).firstChild as HTMLElement
      ).getAttribute("src");
      this.videoModal.show();
    }
  }

  beforeDestroy() {
    document.removeEventListener("click", this.openVideoModal);
  }

  editExternalLinks(html: string) {
    let externalLinkHtml = html.replaceAll("<a", "<a target='_blank'");
    const imgString = this.upArrowIcon;
    externalLinkHtml = externalLinkHtml.replaceAll(
      "</a>",
      "<img src='" +
        imgString +
        "' style='padding-left:.25rem; padding-right:.25rem' /></a>"
    );

    externalLinkHtml = externalLinkHtml.replaceAll(
      "<iframe",
      "<div style='position:relative; z-index:2;'><iframe style='position:relative; z-index:-1; pointer-events: none''"
    );
    externalLinkHtml = externalLinkHtml.replaceAll(
      "</iframe>",
      "</iframe></div>"
    );
    return externalLinkHtml;
  }

  setHeaderSrc() {
    if (this.product.imageFile?.fileUrl) {
      this.headerSrc = this.product.imageFile.fileUrl;
    }
    if (this.product.mp4File?.fileUrl) {
      this.headerSrc = this.product.mp4File.fileUrl;
      this.hasVideo = true;
    }
    if (this.product.webmFile?.fileUrl) {
      this.headerSrc = this.product.webmFile.fileUrl;
      this.hasVideo = true;
    }
  }

  setColumnContent() {
    if (this.publishedContent) {
      if (this.isTablet) {
        this.leftContent = this.publishedContent;
      } else {
        this.leftContent = this.publishedContent.filter((element, index) => {
          return index % 2 !== 0;
        });
        this.rightContent = this.publishedContent.filter((element, index) => {
          return index % 2 === 0;
        });
      }
    }
  }
}
